module.exports = { "default": require("core-js/library/fn/symbol"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/rc-align/~/babel-runtime/core-js/symbol.js
// module id = 484
// module chunks = 0 1